import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69db36bda749570014fa6ce4/busworkshop/src/app/not-found.tsx");
